import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-wrapper">
      <div className="loading"></div>
      <div className="text">Loading app...</div>
    </div>
  )
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js